document.addEventListener("DOMContentLoaded", () => {
  const filterButtons = document.querySelectorAll(".filter .btn");
  const container = document.querySelector(".block-acf.catalog_categories");

  if (!filterButtons.length || !container) return;

  function createFloatingButton() {
    if (document.querySelector("#floatingFilterButton")) return;

    const floatingBtn = document.createElement("button");
    floatingBtn.id = "floatingFilterButton";
    floatingBtn.type = "button";
    floatingBtn.innerHTML = `
      <svg class="text-light-50 rotate-180 w-6 h-6">
        <use xlink:href="#arrow-down"></use>
      </svg>
    `;
    floatingBtn.className =
      "fixed bottom-6 right-6 lg:right-20 lg:bottom-20 z-50 p-3 bg-blauw-600 rounded-full shadow-lg hover:bg-blauw-700 transition-all";
    floatingBtn.setAttribute("aria-label", "Back to filters");

    floatingBtn.addEventListener("click", () => {
      const filterSection = document.querySelector(".filter");
      if (filterSection) {
        const top = filterSection.getBoundingClientRect().top + window.scrollY - 160;
        window.scrollTo({ top, behavior: "smooth" });
      }
    });

    container.appendChild(floatingBtn);
  }

  // Trigger bij klikken op een filterbutton
  filterButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      createFloatingButton();
    });
  });

  // Trigger als er een hash in de URL staat (bijv. #51-75)
if (window.location.hash && document.getElementById(window.location.hash.substring(1))) {
    createFloatingButton();
  }
});